import { createRootRoute, Outlet } from '@tanstack/react-router';
import { SiteProvider } from '@/contexts/site-context';
import { MobileProvider } from '@/contexts/mobile-context';
import { VersionUpdateBanner } from '@/components/common/VersionUpdateBanner';
import NotFound from './-not-found';

export const Route = createRootRoute({
  component: () => (
    <SiteProvider>
      <MobileProvider>
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[9999] focus:rounded-md focus:bg-primary focus:px-4 focus:py-2 focus:text-primary-foreground focus:shadow-lg focus:outline-none"
        >
          Skip to main content
        </a>
        <Outlet />
        <VersionUpdateBanner />
        {/*{import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}*/}
      </MobileProvider>
    </SiteProvider>
  ),
  notFoundComponent: NotFound,
});
